

// Create wallet from FIEL
export const createWalletFromFiel = (data) => ({
    url: '/user/createfielwallet',
    method: 'POST',
    data,
    headers: {
        'Content-Type': 'multipart/form-data'
    }
})

export const importWallet = (data) => ({
    url: '/user/importwallet',
    method: 'POST',
    data,
})

export const createWalletFromFielAsParty = (data) => ({
    url: '/nparticipants/fieladdress',
    method: 'POST',
    data,
    headers: {
        'Content-Type': 'multipart/form-data'
    }
})

// Create signature
export const createSignature = ({
    privateOwner,
    identifier
}) => ({
    url: '/user/fielsign',
    method: 'POST',
    data: {
        privateOwner,
        identifier
    },
})

// Add Owner
export const addOwner = ({
    privateOwner,
    privatePredecessor,
    predecessors,
    identifier,
    current,
    signature
}) => ({
    url: '/user/fieltranslate',
    method: 'POST',
    data: {
        privateOwner,
        privatePredecessor,
        predecessors,
        identifier,
        current,
        signature
    },
})

// Verify Signature
export const verifySignature = ({
    privateOwner,
    predecessors,
    identifier,
    current,
    signature
}) => ({
    url: '/user/fielverify',
    method: 'POST',
    data: {
        privateOwner,
        predecessors,
        identifier,
        current,
        signature
    }
})